import styled from 'styled-components';

import Skeleton from '@/components/atom/Skeleton';
import AppContainer from '@/components/molecules/AppContainer';
import AppHeader from '@/components/molecules/AppHeader';

const PostDetailComment = () => {
  return (
    <Comment>
      <ProfileWrapper>
        <Profile>
          <Skeleton
            style={{
              width: 32,
              height: 32,
              borderRadius: '50%',
              marginRight: 12,
            }}
          />
        </Profile>
        <Column>
          <Skeleton style={{ width: 40, height: 16, marginBottom: 4 }} />
          <Skeleton style={{ width: 50, height: 16 }} />
        </Column>
      </ProfileWrapper>
      <Skeleton
        style={{
          height: 22,
          margin: '16px 0 0 44px',
        }}
      />
      <Skeleton
        style={{
          height: 22,
          margin: '8px 0 16px 44px',
        }}
      />
      <Row>
        <Skeleton
          style={{
            width: 50,
            height: 18,
            marginLeft: 44,
          }}
        />
        <Skeleton
          style={{
            width: 50,
            height: 18,
            marginLeft: 16,
          }}
        />
      </Row>
    </Comment>
  );
};

const PostDetailSkeleton = () => {
  return (
    <Container>
      <AppHeader onClickBackButton={() => null} />
      <DetailWrapper>
        <DetailTop>
          <Skeleton style={{ height: 32, marginBottom: 8 }} />
          <Skeleton style={{ width: '90%', height: 22, marginBottom: 4 }} />
          <Skeleton style={{ width: '80%', height: 22, marginBottom: 4 }} />
          <Skeleton style={{ width: '80%', height: 22, marginBottom: 20 }} />
          <Skeleton style={{ height: 200, marginTop: 20, marginBottom: 24 }} />
        </DetailTop>
        <ProfileWrapper>
          <Profile>
            <Skeleton
              style={{
                width: 32,
                height: 32,
                borderRadius: '50%',
                marginRight: 12,
              }}
            />
          </Profile>
          <Column>
            <Skeleton style={{ width: 40, height: 16, marginBottom: 4 }} />
            <Skeleton style={{ width: 50, height: 16 }} />
          </Column>
        </ProfileWrapper>
      </DetailWrapper>
      <ButtonRow>
        <BottomButton>
          <Skeleton style={{ width: 80, height: 22 }} />
        </BottomButton>
        <BottomButton>
          <Skeleton style={{ width: 80, height: 22 }} />
        </BottomButton>
      </ButtonRow>

      <CommentWrapper>
        <CommentTitle>
          <Skeleton style={{ width: 40, height: 22 }} />
          <Skeleton style={{ width: 40, height: 22, marginLeft: 8 }} />
        </CommentTitle>
        {Array.from({ length: 4 }).map((_, i) => (
          <PostDetailComment key={`skeleton_${i}`} />
        ))}
      </CommentWrapper>
    </Container>
  );
};

export default PostDetailSkeleton;

const Container = styled(AppContainer)`
  width: 100%;
  ${({ theme }) => `background: ${theme.color.gray40}`};
`;

const Row = styled.div`
  display: flex;
  align-items: center;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const DetailWrapper = styled.div`
  padding: 24px;
  ${({ theme }) => `background: ${theme.color.white}`};
`;
const DetailTop = styled.div``;

const ProfileWrapper = styled(Row)`
  height: 36px;
`;
const Profile = styled.div``;
const ButtonRow = styled.div`
  display: flex;
  align-items: center;
  ${({ theme }) => `background: ${theme.color.white}`};
`;

const BottomButton = styled.div`
  flex: 1;
  align-items: center;
  padding: 18px 0;

  ${({ theme }) => `
    border: 1px solid ${theme.color.gray50};
  `};

  & > div {
    margin: auto;
  }
  &:not(first-child) {
    border-left: none;
  }
`;

const CommentWrapper = styled.div`
  background: ${({ theme }) => theme.color.gray40};
  margin-top: 12px;
`;

const CommentTitle = styled(Row)`
  background: ${({ theme }) => theme.color.white};
  padding: 32px 24px 8px;
`;

const Comment = styled.div`
  background: ${({ theme }) => theme.color.white};
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 15px;
`;
